import { ReactElement } from "react";
import dynamic from "next/dynamic";

import MintLayout from "../../components/Layouts/Mint";
import SEO from "../../components/Seo/Seo";

const TrialMint = dynamic(
  () => import("../../components/TrialMint/TrialMint"),
  {
    ssr: false
  }
);

const Trial = () => (
  <>
    <SEO
      title="Coinage Trial Pass | Coinage Media"
      image="https://www.coinage.media/trial.png"
      description="Mint to unlock all of Coinage's award-winning content ad-free and help support community-owned media."
    />
    <TrialMint />
  </>
);

Trial.getLayout = function getLayout(page: ReactElement) {
  return <MintLayout hideMenu>{page}</MintLayout>;
};

export default Trial;
